import classes from "./formReadOnlyContent.module.css";

export const FormReadonlyContent = ({
  id,
  label,
  content = "",
  required = false,
  style,
  className,
}) => {
  return (
    <div className={`${classes.wrapper} ${className || ""}`} style={style}>
      <div className={`${classes.inputBox} ${classes.readOnlyBox}`}>
        <div
          id={id}
          className={classes.content}
          dangerouslySetInnerHTML={{ __html: content }}
        />
        <label htmlFor={id} className={classes.floatingLabel}>
          {label}
          {required && <span className={classes.asterisk}>*</span>}
        </label>
      </div>
    </div>
  );
};
